import React from "react";
import styles from "./SectionWrapper.module.css";
import classnames from "classnames";
import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";
import { FEATURE_STATUS } from "features/Account/Account.constants";
import { useDesktopMediaQuery } from "features/Common/hooks/useDesktopMediaQuery";

export const SectionWrapper = ({
  config = {},
  showDivider = false,
  customJSX = <></>,
  descriptionSpanJSX = <></>,
  className = "",
}) => {
  const isDesktop = useDesktopMediaQuery();
  const { title = "", description = "" } = config;

  const sectionConfig = useAdminPanelStore((state) => state.sectionConfig);

  // hide this section , if all subsectionas are hidden.
  const allSubSectionHidden = config.subSectionConfig?.every(
    (item) => sectionConfig[item.key]?.status === FEATURE_STATUS.HIDDEN
  );

  if (allSubSectionHidden) return <></>;

  return (
    <>
      <div
        className={classnames(
          styles.mainWrapper,
          showDivider && styles.divider,
          className
        )}
      >
        <div className={styles.titleWrapper}>
          <div className={styles.title}>{title}</div>
          <div className={styles.description}>
            {description}
            <span className={isDesktop ? "" : "tw-inline-block"}>
              {descriptionSpanJSX}
            </span>
          </div>
        </div>
        {/* @dev -> right side of the section can be managed via customJSX */}
        {customJSX}
      </div>
    </>
  );
};
